module.exports = __webpack_public_path__ + "img/outpatientPersonReturnRate.8b991124.svg";